import { t, Trans } from "@lingui/macro";
import Checkbox from "components/Checkbox/Checkbox";
import Modal from "components/Modal/Modal";
import { ethers } from "ethers";
import RewardIcon from "img/earn/rewards.svg";
import { callContract, contractFetcher } from "lib/contracts";
import { useEffect, useState } from "react";
import "./Earn.scss";
import RewardRouter from "abis/RewardRouter.json";
import { useLocalStorageSerializeKey } from "lib/localStorage";
import { useWeb3React } from "@web3-react/core";
import { BASE, FANTOM, getConstant } from "config/chains";
import { useChainId } from "lib/chains";
import { getContract } from "config/contracts";
import { approveTokens } from "domain/tokens";
import useSWR from "swr";
import Token from "abis/Token.json";
import { GLP_DECIMALS, PLACEHOLDER_ACCOUNT, USD_DECIMALS } from "lib/legacy";
import { formatAddKeysAmount, formatAmount, formatAmountFree, formatKeyAmount, formatNumber } from "lib/numbers";
import Tooltip from "components/Tooltip/Tooltip";
import StatsTooltipRow from "components/StatsTooltip/StatsTooltipRow";
import { useGmxPrice } from "domain/legacy";
import axios from "axios";
import NewVaultJson from "abis/NewVault.json";
import { Link } from "react-router-dom";
import ExternalLink from "components/ExternalLink/ExternalLink";
import StatsTooltip from "components/StatsTooltip/StatsTooltip";
import TooltipHTML from "components/Tooltip/TooltipHTML";
import GMXAprTooltip from "components/Stake/GMXAprTooltip";
function ClaimModal(props) {
  const {
    isVisible,
    setIsVisible,
    rewardRouterAddress,
    library,
    chainId,
    setPendingTxns,
    nativeTokenSymbol,
    wrappedTokenSymbol,
  } = props;
  const [isClaiming, setIsClaiming] = useState(false);
  const [shouldClaimGmx, setShouldClaimGmx] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-claim-should-claim-gmx"],
    true
  );
  const [shouldClaimEsGmx, setShouldClaimEsGmx] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-claim-should-claim-es-gmx"],
    true
  );
  const [shouldClaimWeth, setShouldClaimWeth] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-claim-should-claim-weth"],
    true
  );
  const [shouldConvertWeth, setShouldConvertWeth] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-claim-should-convert-weth"],
    true
  );

  const isPrimaryEnabled = () => {
    return !isClaiming;
  };

  const getPrimaryText = () => {
    if (isClaiming) {
      return `Claiming...`;
    }
    return `Claim`;
  };

  const onClickPrimary = () => {
    setIsClaiming(true);

    const contract = new ethers.Contract(rewardRouterAddress, RewardRouter.abi, library.getSigner());
    callContract(
      chainId,
      contract,
      "handleRewards",
      [
        shouldClaimGmx,
        false, // shouldStakeGmx
        shouldClaimEsGmx,
        false, // shouldStakeEsGmx
        false, // shouldStakeMultiplierPoints
        shouldClaimWeth,
        shouldConvertWeth,
      ],
      {
        sentMsg: `Claim submitted.`,
        failMsg: `Claim failed.`,
        successMsg: `Claim completed!`,
        setPendingTxns,
      }
    )
      .then(async (res) => {
        setIsVisible(false);
      })
      .finally(() => {
        setIsClaiming(false);
      });
  };

  const toggleConvertWeth = (value) => {
    if (value) {
      setShouldClaimWeth(true);
    }
    setShouldConvertWeth(value);
  };

  return (
    <div className="StakeModal">
      <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={`Claim Rewards`}>
        <div className="CompoundModal-menu">
          <div>
            <Checkbox isChecked={shouldClaimGmx} setIsChecked={setShouldClaimGmx}>
              <span>Claim MMY Rewards</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldClaimEsGmx} setIsChecked={setShouldClaimEsGmx}>
              <span>Claim esMMY Rewards</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldClaimWeth} setIsChecked={setShouldClaimWeth} disabled={shouldConvertWeth}>
              <span>Claim {wrappedTokenSymbol} Rewards</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldConvertWeth} setIsChecked={toggleConvertWeth}>
              <span>
                Convert {wrappedTokenSymbol} to {nativeTokenSymbol}
              </span>
            </Checkbox>
          </div>
        </div>
        <div className="Exchange-swap-button-container">
          <button className="App-cta Exchange-swap-button" onClick={onClickPrimary} disabled={!isPrimaryEnabled()}>
            {getPrimaryText()}
          </button>
        </div>
      </Modal>
    </div>
  );
}
function CompoundModal(props) {
  const {
    isVisible,
    setIsVisible,
    rewardRouterAddress,
    active,
    account,
    library,
    chainId,
    setPendingTxns,
    totalVesterRewards,
    nativeTokenSymbol,
    wrappedTokenSymbol,
  } = props;
  const [isCompounding, setIsCompounding] = useState(false);
  // const shouldClaimGmx = false; // delete here
  // const shouldStakeGmx = false; // delete here

  // const [shouldClaimGmxtest,setShouldClaimGmx] = useLocalStorageSerializeKey([chainId, "StakeV2-compound-should-claim-gmx"], true); // delete here
  // const [shouldStakeGmxtest,setShouldStakeGmx] = useLocalStorageSerializeKey([chainId, "StakeV2-compound-should-stake-gmx"], true); // delete here

  // open here //

  const [shouldClaimGmx, setShouldClaimGmx] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-compound-should-claim-gmx"],
    true
  );
  const [shouldStakeGmx, setShouldStakeGmx] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-compound-should-stake-gmx"],
    true
  );

  // open here //

  const [shouldClaimEsGmx, setShouldClaimEsGmx] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-compound-should-claim-es-gmx"],
    true
  );
  const [shouldStakeEsGmx, setShouldStakeEsGmx] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-compound-should-stake-es-gmx"],
    true
  );
  const [shouldStakeMultiplierPoints, setShouldStakeMultiplierPoints] = useState(true);
  const [shouldClaimWeth, setShouldClaimWeth] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-compound-should-claim-weth"],
    true
  );
  const [shouldConvertWeth, setShouldConvertWeth] = useLocalStorageSerializeKey(
    [chainId, "StakeV2-compound-should-convert-weth"],
    true
  );

  const gmxAddress = getContract(chainId, "GMX");
  const stakedGmxTrackerAddress = getContract(chainId, "StakedGmxTracker");

  const [isApproving, setIsApproving] = useState(false);

  const { data: tokenAllowance } = useSWR(
    active && [active, chainId, gmxAddress, "allowance", account, stakedGmxTrackerAddress],
    {
      fetcher: contractFetcher(library, Token),
    }
  );

  const needApproval = shouldStakeGmx && tokenAllowance && totalVesterRewards && totalVesterRewards.gt(tokenAllowance);

  const isPrimaryEnabled = () => {
    return !isCompounding && !isApproving && !isCompounding;
  };

  const getPrimaryText = () => {
    if (isApproving) {
      return `Approving MMY...`;
    }
    if (needApproval) {
      return `Approve MMY`;
    }
    if (isCompounding) {
      return `Compounding...`;
    }
    return `Compound`;
  };

  const onClickPrimary = () => {
    if (needApproval) {
      approveTokens({
        setIsApproving,
        library,
        tokenAddress: gmxAddress,
        spender: stakedGmxTrackerAddress,
        chainId,
      });
      return;
    }

    setIsCompounding(true);

    const contract = new ethers.Contract(rewardRouterAddress, RewardRouter.abi, library.getSigner());
    callContract(
      chainId,
      contract,
      "handleRewards",
      [
        shouldClaimGmx || shouldStakeGmx,
        shouldStakeGmx,
        shouldClaimEsGmx || shouldStakeEsGmx,
        shouldStakeEsGmx,
        shouldStakeMultiplierPoints,
        shouldClaimWeth || shouldConvertWeth,
        shouldConvertWeth,
      ],
      {
        sentMsg: `Compound submitted!`,
        failMsg: `Compound failed.`,
        successMsg: `Compound completed!`,
        setPendingTxns,
      }
    )
      .then(async (res) => {
        setIsVisible(false);
      })
      .finally(() => {
        setIsCompounding(false);
      });
  };

  const toggleShouldStakeGmx = (value) => {
    if (value) {
      setShouldClaimGmx(true);
    }
    setShouldStakeGmx(value);
  };

  const toggleShouldStakeEsGmx = (value) => {
    if (value) {
      setShouldClaimEsGmx(true);
    }
    setShouldStakeEsGmx(value);
  };

  const toggleConvertWeth = (value) => {
    if (value) {
      setShouldClaimWeth(true);
    }
    setShouldConvertWeth(value);
  };

  return (
    <div className="StakeModal">
      <Modal isVisible={isVisible} setIsVisible={setIsVisible} label={`Compound Rewards`}>
        <div className="CompoundModal-menu">
          <div>
            <Checkbox
              isChecked={shouldStakeMultiplierPoints}
              setIsChecked={setShouldStakeMultiplierPoints}
              disabled={true}
            >
              <span>Stake Multiplier Points</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldClaimGmx} setIsChecked={setShouldClaimGmx} disabled={shouldStakeGmx}>
              <span>Claim MMY Rewards</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldStakeGmx} setIsChecked={toggleShouldStakeGmx}>
              <span>Stake MMY Rewards</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldClaimEsGmx} setIsChecked={setShouldClaimEsGmx} disabled={shouldStakeEsGmx}>
              <span>Claim esMMY Rewards</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldStakeEsGmx} setIsChecked={toggleShouldStakeEsGmx}>
              <span>Stake esMMY Rewards</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldClaimWeth} setIsChecked={setShouldClaimWeth} disabled={shouldConvertWeth}>
              <span>Claim {wrappedTokenSymbol} Rewards</span>
            </Checkbox>
          </div>
          <div>
            <Checkbox isChecked={shouldConvertWeth} setIsChecked={toggleConvertWeth}>
              <span>
                Convert {wrappedTokenSymbol} to {nativeTokenSymbol}
              </span>
            </Checkbox>
          </div>
        </div>
        <div className="Exchange-swap-button-container">
          <button className="App-cta Exchange-swap-button" onClick={onClickPrimary} disabled={!isPrimaryEnabled()}>
            {getPrimaryText()}
          </button>
        </div>
      </Modal>
    </div>
  );
}
const EarnOverview = (props) => {
  const { chainId } = useChainId();
  const { setPendingTxns, processedData, connectWallet, vestingData } = props;
  const [isClaimModalVisible, setIsClaimModalVisible] = useState(false);
  const [isCompoundModalVisible, setIsCompoundModalVisible] = useState(false);
  const rewardRouterAddress = getContract(chainId, "RewardRouter");
  const { active, library, account } = useWeb3React();
  const wrappedTokenSymbol = getConstant(chainId, "wrappedTokenSymbol");
  const nativeTokenSymbol = getConstant(chainId, "nativeTokenSymbol");

  const { gmxPrice } = useGmxPrice(chainId, {}, active);
  const priceTokenMMYVault = Number(formatAmount(gmxPrice, USD_DECIMALS));
  const priceTokenMLPVault = Number(formatKeyAmount(processedData, "glpPrice", USD_DECIMALS, 3, true));
  const [statsMMYWFTM, setStatsMMYWFTM] = useState({
    price: 0,
    apr: 1,
  });
  const MMY_WFTM_Address =
    chainId === FANTOM ? "0xdc935ffe9f9c972b7b304e0b7e61eb774037e394" : "0x104d0312f95a1b3056435d19668f2272ab1e7df2";
  const priceStatsMMYWFTM = statsMMYWFTM?.price;

  const fetchStatsMMYWFTM = async () => {
    const res = await axios.get(
      chainId === FANTOM
        ? `https://eqapi-main-7cmme.ondigitalocean.app/api/v2/pairs`
        : "https://api.velodrome.finance/api/v1/pairs",
      {}
    );
    if (chainId === FANTOM) {
      if (res && res.data) {
        const { apr, tvl, totalSupply } = res.data.data.find((item) => item.address.toLowerCase() === MMY_WFTM_Address);

        setStatsMMYWFTM({
          price: tvl / totalSupply,
          apr,
        });
      }
    } else {
      if (
        res &&
        res.data &&
        res.data.data &&
        res.data.data.find((item) => item.address.toLowerCase() === MMY_WFTM_Address)
      ) {
        const { apr, tvl, totalSupply } = res.data.data.find((item) => item.address.toLowerCase() === MMY_WFTM_Address);

        setStatsMMYWFTM({
          price: tvl / totalSupply,
          apr,
        });
      }
    }
  };

  // const vaultAddress = getContract(chainId, "Vault");
  const vaultMMYAddress = getContract(chainId, "VaultMMY");
  const vaultMLPAddress = getContract(chainId, "VaultMLP");
  const vaultMMY_WFTMAddress = getContract(chainId, chainId === FANTOM ? "VaultMMY_WFTM" : "VaultMMY_WETH");
  const { data: balanceOfMMY } = useSWR(
    () => [`StakeV2:balanceOf:${active}:${account}`, chainId, vaultMMYAddress, "balanceOf"],
    {
      fetcher: contractFetcher(library, NewVaultJson, [account || PLACEHOLDER_ACCOUNT]),
    }
  );
  const { data: balanceOfMLP } = useSWR(
    [`StakeV2:balanceOf:${active}:${account}`, chainId, vaultMLPAddress, "balanceOf"],
    {
      fetcher: contractFetcher(library, NewVaultJson, [account || PLACEHOLDER_ACCOUNT]),
    }
  );
  const { data: balanceOfMMY_WFTM } = useSWR(
    () => [`StakeV2:balanceOf:${active}:${account}`, chainId, vaultMMY_WFTMAddress, "balanceOf"],
    {
      fetcher: contractFetcher(library, NewVaultJson, [account || PLACEHOLDER_ACCOUNT]),
    }
  );
  const { data: pricePerFullShareMMY } = useSWR(
    () => [`StakeV2:getPricePerFullShareMMY:${active}:${account}`, chainId, vaultMMYAddress, "getPricePerFullShare"],
    {
      fetcher: contractFetcher(library, NewVaultJson),
    }
  );
  const { data: pricePerFullShareMLP } = useSWR(
    () => [`StakeV2:getPricePerFullShareMLP:${active}:${account}`, chainId, vaultMLPAddress, "getPricePerFullShare"],
    {
      fetcher: contractFetcher(library, NewVaultJson),
    }
  );
  const { data: pricePerFullShareMMY_WFTM } = useSWR(
    () => [
      `StakeV2:getPricePerFullShareMMY_WFTM:${active}:${account}`,
      chainId,
      vaultMMY_WFTMAddress,
      "getPricePerFullShare",
    ],
    {
      fetcher: contractFetcher(library, NewVaultJson),
    }
  );

  const AmountMMMVaultDeposit = formatAmountFree(balanceOfMMY, 18);
  const AmountMLPVaultDeposit = formatAmountFree(balanceOfMLP, 18);
  const AmountMMY_WFTMVaultDeposit = formatAmountFree(balanceOfMMY_WFTM, 18);

  const rateWithdrawMMYVault = formatAmountFree(pricePerFullShareMMY, 18);
  const rateWithdrawMLPVault = formatAmountFree(pricePerFullShareMLP, 18);
  const rateWithdrawMMY_WFTMVault = formatAmountFree(pricePerFullShareMMY_WFTM, 18);

  let depositDollar = "0";
  const checkAvailableNumber = (number) => {
    if (!number) return 0;
    if (number === "...") return 0;
    return number;
  };
  if (AmountMMMVaultDeposit || AmountMLPVaultDeposit || AmountMMY_WFTMVaultDeposit) {
    depositDollar = formatNumber(
      checkAvailableNumber(AmountMMMVaultDeposit || 0) *
        checkAvailableNumber(priceTokenMMYVault || 0) *
        checkAvailableNumber(rateWithdrawMMYVault || 0) +
        checkAvailableNumber(AmountMLPVaultDeposit || 0) *
          checkAvailableNumber(priceTokenMLPVault || 0) *
          checkAvailableNumber(rateWithdrawMLPVault || 0) +
        checkAvailableNumber(AmountMMY_WFTMVaultDeposit || 0) *
          checkAvailableNumber(priceStatsMMYWFTM || 0) *
          checkAvailableNumber(rateWithdrawMMY_WFTMVault || 0),
      2
    );
  }
  // console.log("????", {
  //   AmountMMMVaultDeposit,
  //   priceTokenMMYVault, rateWithdrawMMYVault,
  //   AmountMLPVaultDeposit, priceTokenMLPVault, rateWithdrawMLPVault,
  //   AmountMMY_WFTMVaultDeposit, priceStatsMMYWFTM, rateWithdrawMMY_WFTMVault
  // });
  useEffect(() => {
    fetchStatsMMYWFTM();

    const interval = setInterval(async () => {
      fetchStatsMMYWFTM();
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="earn-content-container">
      <div className="tab-content-title">Overview</div>
      <div className="tab-content-desc">
        By staking MMY or MLP tokens on the Fantom, Optimism, Arbitrum and Base networks, you can earn protocol income and
        rewards. <ExternalLink href="https://docs.mummy.finance/rewards">Learn More</ExternalLink>.
      </div>
      <div className="tab-main-content">
        <div className="main-content left-content">
          <div className="overview-container">
            <div className="main-title">Total rewards</div>
            <div className="total-reward">
              <div className="reward-img">
                <img alt="icon" src={RewardIcon} />
              </div>
              <div className="reward-info">
                <div className="reward-title">Total rewards</div>
                <div className="reward-value">
                  {processedData.totalRewardsUsd ? (
                    `$${formatKeyAmount(processedData, "totalRewardsUsd", USD_DECIMALS, 2, true)}`
                  ) : (
                    <div className="skeleton-box" />
                  )}
                </div>
              </div>
            </div>
            <div className="overview-content-container">
              <div className="overview-content">
                <div className="title">
                  {nativeTokenSymbol} ({wrappedTokenSymbol})
                </div>
                {processedData.totalNativeTokenRewards ? (
                  <div className="value native-token-reward">
                    <TooltipHTML
                      position="right-bottom"
                      className="nowrap"
                      handle={`${formatKeyAmount(
                        processedData,
                        "totalNativeTokenRewards",
                        18,
                        4,
                        true
                      )} <span class="reward-dollar">$${formatKeyAmount(
                        processedData,
                        "totalNativeTokenRewardsUsd",
                        USD_DECIMALS,
                        2,
                        true
                      )}</span>`}
                      renderContent={() => (
                        <>
                          <StatsTooltipRow
                            label={`MMY & esMMY`}
                            showDollar={false}
                            value={`${formatKeyAmount(
                              processedData,
                              "feeGmxTrackerRewards",
                              18,
                              4,
                              true
                            )} ($${formatKeyAmount(processedData, "feeGmxTrackerRewardsUsd", USD_DECIMALS, 2, true)})`}
                          />
                          <StatsTooltipRow
                            label={`MLP`}
                            showDollar={false}
                            value={`${formatKeyAmount(
                              processedData,
                              "feeGlpTrackerRewards",
                              18,
                              4,
                              true
                            )} ($${formatKeyAmount(processedData, "feeGlpTrackerRewardsUsd", USD_DECIMALS, 2, true)})`}
                          />
                        </>
                      )}
                    />
                  </div>
                ) : (
                  <div className="value">
                    <div className="skeleton-box" style={{ width: "65px", height: "20px" }} />
                  </div>
                )}
              </div>
              <div className="overview-content">
                <div className="title">MMY</div>
                {processedData.totalVesterRewards ? (
                  <div className="value native-token-reward">
                    <TooltipHTML
                      position="right-bottom"
                      className="nowrap"
                      handle={`${formatKeyAmount(
                        processedData,
                        "totalVesterRewards",
                        18,
                        4,
                        true
                      )} <span class="reward-dollar">$${formatKeyAmount(
                        processedData,
                        "totalVesterRewardsUsd",
                        USD_DECIMALS,
                        2,
                        true
                      )}</span>`}
                      renderContent={() => (
                        <>
                          <StatsTooltipRow
                            label={`MMY Vault`}
                            showDollar={false}
                            value={`${formatKeyAmount(
                              processedData,
                              "gmxVesterRewards",
                              18,
                              4,
                              true
                            )} ($${formatKeyAmount(processedData, "gmxVesterRewardsUsd", USD_DECIMALS, 2, true)})`}
                          />
                          <StatsTooltipRow
                            label={`MLP Vault`}
                            showDollar={false}
                            value={`${formatKeyAmount(processedData, "glpVesterRewards", 18, 4)} ($${formatKeyAmount(
                              processedData,
                              "glpVesterRewardsUsd",
                              USD_DECIMALS,
                              2,
                              true
                            )})`}
                          />
                        </>
                      )}
                    />
                  </div>
                ) : (
                  <div className="value">
                    <div className="skeleton-box" style={{ width: "65px", height: "20px" }} />
                  </div>
                )}
              </div>
              <div className="overview-content">
                <div className="title">esMMY</div>
                {processedData.totalEsGmxRewards ? (
                  <div className="value native-token-reward">
                    <TooltipHTML
                      position="right-bottom"
                      className="nowrap"
                      handle={`${formatKeyAmount(
                        processedData,
                        "totalEsGmxRewards",
                        18,
                        4,
                        true
                      )} <span class="reward-dollar">$${formatKeyAmount(
                        processedData,
                        "totalEsGmxRewardsUsd",
                        USD_DECIMALS,
                        2,
                        true
                      )}</span>`}
                      renderContent={() => (
                        <>
                          <StatsTooltipRow
                            label={`MMY & esMMY`}
                            showDollar={false}
                            value={`${formatKeyAmount(
                              processedData,
                              "stakedGmxTrackerRewards",
                              18,
                              4,
                              true
                            )} ($${formatKeyAmount(
                              processedData,
                              "stakedGmxTrackerRewardsUsd",
                              USD_DECIMALS,
                              2,
                              true
                            )})`}
                          />
                          <StatsTooltipRow
                            label={`MLP`}
                            showDollar={false}
                            value={`${formatKeyAmount(
                              processedData,
                              "stakedGlpTrackerRewards",
                              18,
                              4
                            )} ($${formatKeyAmount(
                              processedData,
                              "stakedGlpTrackerRewardsUsd",
                              USD_DECIMALS,
                              2,
                              true
                            )})`}
                          />
                        </>
                      )}
                    />
                  </div>
                ) : (
                  <div className="value">
                    <div className="skeleton-box" style={{ width: "65px", height: "20px" }} />
                  </div>
                )}
              </div>
              <div className="overview-content">
                <div className="title">Multiplier Points</div>
                <div className="value">
                  {processedData?.bonusGmxTrackerRewards ? (
                    `${formatKeyAmount(processedData, "bonusGmxTrackerRewards", 18, 4, true)}`
                  ) : (
                    <div className="skeleton-box" style={{ width: "65px", height: "20px" }} />
                  )}
                </div>
              </div>
              <div className="overview-content">
                <div className="title">Staked Multiplier Points</div>
                <div className="value">
                  {processedData?.bnGmxInFeeGmx ? (
                    `${formatKeyAmount(processedData, "bnGmxInFeeGmx", 18, 4, true)}`
                  ) : (
                    <div className="skeleton-box" style={{ width: "65px", height: "20px" }} />
                  )}
                </div>
              </div>
            </div>
            <div className="actions-contaner">
              {account && (
                <button className="App-button-option App-card-option" onClick={() => setIsCompoundModalVisible(true)}>
                  <span>Compound</span>
                </button>
              )}
              {account && (
                <button
                  className="App-button-option App-card-option border-btn"
                  onClick={() => setIsClaimModalVisible(true)}
                >
                  <span>Claim</span>
                </button>
              )}

              {!account && (
                <button className="App-button-option App-card-option" onClick={() => connectWallet()}>
                  Connect Wallet
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="main-content right-content">
          <div className="right-content-box">
            <div className="box-info">
              <div className="title">MMY & esMMY staked</div>
              {processedData.gmxInStakedGmx ? (
                <div className="value">
                  <Tooltip
                    handle={formatAddKeysAmount(processedData, "gmxInStakedGmx", "esGmxInStakedGmx", 18, 2, true)}
                    position="right-bottom"
                    renderContent={() => {
                      return (
                        <>
                          <StatsTooltipRow
                            showDollar={false}
                            label="MMY"
                            value={
                              formatKeyAmount(processedData, "gmxInStakedGmx", 18, 2, true) +
                              " ($" +
                              formatKeyAmount(processedData, "gmxInStakedGmxUsd", USD_DECIMALS, 2, true) +
                              ")"
                            }
                          />

                          <StatsTooltipRow
                            showDollar={false}
                            label="esMMY"
                            value={
                              formatKeyAmount(processedData, "esGmxInStakedGmx", 18, 2, true) +
                              " ($" +
                              formatKeyAmount(processedData, "esGmxInStakedGmxUsd", USD_DECIMALS, 2, true) +
                              ")"
                            }
                          />
                        </>
                      );
                    }}
                  />
                  <span className="sub-value">
                    $
                    {formatAddKeysAmount(
                      processedData,
                      "gmxInStakedGmxUsd",
                      "esGmxInStakedGmxUsd",
                      USD_DECIMALS,
                      2,
                      true
                    )}
                  </span>
                </div>
              ) : (
                <div className="value">
                  <div className="skeleton-box" style={{ width: "65px", height: "20px" }} />
                </div>
              )}
            </div>
            <div className="box-info">
              <div className="title">APR</div>
              <div className="value">
                <div className="box-apr">
                  {processedData.gmxAprTotalWithBoost ? (
                    <Tooltip
                      className="tooltip-apr"
                      handle={
                        <div style={{ color: "#03F5AE" }}>
                          {" "}
                          {formatKeyAmount(processedData, "gmxAprTotalWithBoost", 2, 2, true)}%
                        </div>
                      }
                      position="right-bottom"
                      renderContent={() => (
                        <GMXAprTooltip processedData={processedData} nativeTokenSymbol={nativeTokenSymbol} />
                      )}
                    />
                  ) : (
                    <div className="skeleton-box" style={{ width: "60px", height: "20px" }} />
                  )}
                </div>
              </div>
            </div>
            <Link to="/earn-v2/mmy-esmmy" className="App-button-option App-card-option border-btn">
              <span>Details</span>
            </Link>
          </div>
          <div className="right-content-box">
            <div className="box-info">
              <div className="title">MLP staked</div>
              {processedData?.glpBalance ? (
                <div className="value">
                  {formatKeyAmount(processedData, "glpBalance", GLP_DECIMALS, 2, true)}
                  <span className="sub-value">
                    ${formatKeyAmount(processedData, "glpBalanceUsd", USD_DECIMALS, 2, true)}
                  </span>
                </div>
              ) : (
                <div className="value">
                  <div className="skeleton-box" style={{ width: "65px", height: "20px" }} />
                </div>
              )}
            </div>
            <div className="box-info">
              <div className="title">APR</div>
              <div className="value">
                <div className="box-apr">
                  {processedData.glpAprTotal ? (
                    <Tooltip
                      className="tooltip-apr"
                      handle={
                        <div style={{ color: "#03F5AE" }}>
                          {formatKeyAmount(processedData, "glpAprTotal", 2, 2, true)}%
                        </div>
                      }
                      position="right-bottom"
                      renderContent={() => {
                        return (
                          <>
                            <StatsTooltipRow
                              label={`${nativeTokenSymbol} (${wrappedTokenSymbol}) APR`}
                              value={`${formatKeyAmount(processedData, "glpAprForNativeToken", 2, 2, true)}%`}
                              showDollar={false}
                            />
                            <StatsTooltipRow
                              label="Escrowed MMY APR"
                              value={`${formatKeyAmount(processedData, "glpAprForEsGmx", 2, 2, true)}%`}
                              showDollar={false}
                            />
                            <div style={{ marginTop: "8px", fontWeight: 400 }}>
                              <span>APRs are updated weekly and will depend on the fees collected for the week.</span>
                            </div>
                          </>
                        );
                      }}
                    />
                  ) : (
                    <div className="skeleton-box" style={{ width: "80px", height: "20px" }} />
                  )}
                </div>
              </div>
            </div>
            <Link to="/earn-v2/mlp" className="App-button-option App-card-option border-btn">
              <span>Details</span>
            </Link>
          </div>
          <div className="right-content-box">
            <div className="box-info">
              <div className="title">Vesting status</div>
              {vestingData?.gmxVesterClaimSum ? (
                <div className="value">
                  <Tooltip
                    handle={`${formatKeyAmount(vestingData, "gmxVesterClaimSum", 18, 4, true)} / ${formatKeyAmount(
                      vestingData,
                      "gmxVesterVestedAmount",
                      18,
                      4,
                      true
                    )}`}
                    position="right-bottom"
                    renderContent={() => {
                      return (
                        <div>
                          <span>
                            <span
                              style={{
                                color: "#ffffff",
                                fontWeight: 700,
                              }}
                            >
                              {formatKeyAmount(vestingData, "gmxVesterClaimSum", 18, 4, true)}
                            </span>{" "}
                            tokens have been converted to MMY from the{" "}
                            <span
                              style={{
                                color: "#ffffff",
                                fontWeight: 700,
                              }}
                            >
                              {formatKeyAmount(vestingData, "gmxVesterVestedAmount", 18, 4, true)} esMMY
                            </span>{" "}
                            deposited for vesting.
                          </span>
                        </div>
                      );
                    }}
                  />
                </div>
              ) : (
                <div className="value">
                  <div className="skeleton-box" style={{ width: "65px", height: "20px" }} />
                </div>
              )}
            </div>
            <Link to="/earn-v2/vest" className="App-button-option App-card-option border-btn">
              <span>Details</span>
            </Link>
          </div>
          {/* TODO legacy */}
          {chainId !== FANTOM && chainId !== BASE && <div className="right-content-box">
            <div className="box-info">
              <div className="title">Deposited in vault</div>
              <div className="value">${depositDollar}</div>
            </div>
             <Link to="/earn-v2/vault" className="App-button-option App-card-option border-btn">
              <span>Details</span>
            </Link> 
          </div>}
        </div>
      </div>
      <ClaimModal
        active={active}
        account={account}
        setPendingTxns={setPendingTxns}
        isVisible={isClaimModalVisible}
        setIsVisible={setIsClaimModalVisible}
        rewardRouterAddress={rewardRouterAddress}
        totalVesterRewards={processedData?.totalVesterRewards}
        wrappedTokenSymbol={wrappedTokenSymbol}
        nativeTokenSymbol={nativeTokenSymbol}
        library={library}
        chainId={chainId}
      />
      <CompoundModal
        active={active}
        account={account}
        setPendingTxns={setPendingTxns}
        isVisible={isCompoundModalVisible}
        setIsVisible={setIsCompoundModalVisible}
        rewardRouterAddress={rewardRouterAddress}
        totalVesterRewards={processedData.totalVesterRewards}
        wrappedTokenSymbol={wrappedTokenSymbol}
        nativeTokenSymbol={nativeTokenSymbol}
        library={library}
        chainId={chainId}
      />
    </div>
  );
};
export default EarnOverview;
